import React from 'react'
import styled from 'styled-components'
import { LOGO_IMG, BASE_BG_COLOR, BASE_FONT_COLOR } from '../../const/config';

const Wrapper = styled.header`
height: 48px;
  width: 100vw;
  background-color: ${BASE_BG_COLOR};
  color: ${BASE_FONT_COLOR};
  border-bottom: 0.5px solid #666;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  float:left;
  position: fixed;
  z-index: 10;
`
const Logo = styled.img`
width: 150px;
padding-top: 10px;
padding-left: 15px;
`
const Header = (props) => {

  return (
    <Wrapper>
      <Logo src={LOGO_IMG}></Logo>
      </Wrapper>
  )
}
export default Header;
